import { Map } from 'immutable'
import {
  loadingAsyncState,
  none,
  Option,
  some,
} from 'widgets-for-react'
import { CustomBlock } from '../wordpress/types_and_parser/custom_blocks.mod'
import {
  downloadBlockClasses,
  mediaBlockClasses,
  quoteBlockClasses,
  iframeBlockClasses,
  rekenToolBlockClasses,
  textBlockClasses,
  formBlockClasses,
  tableBlockClasses,
  PageNavigationBlockClasses
} from './blocks/style.mod'
import { CustomBlockData } from './blocks/custom_blocks/types.mod'
import { conneqt_x_map, get_addresses } from './blocks/custom_blocks/widgets/mapBlock'
import { MediaBlockStyle } from './blocks/custom_blocks/widgets/mediaBlock.mod'
import { QuoteBlockStyle } from './blocks/custom_blocks/widgets/quoteBlock.mod'
import { DownloadBlockStyle } from '../cms/blocks/widgets/downloadBlock.gen'
import { LatestBlockProps } from './blocks/custom_blocks/widgets/latestBlock'
import { getFormState } from '../form/api'
import { buttonWrapper, linkWrapper } from '../cms/blocks/utils.gen'
import { PublicSite_CustomPageData } from './application.mod'
import { parseTableHtml } from './blocks/custom_blocks/widgets/tableBlock.mod'
import { toRelativeUrl } from '../../utils';
import { FindHighlightVideoItem, FindVideoLibraryItems, GetVideoLibraryFilters } from '../wordpress/wordpress_api'
import { AllVideosText } from './blocks/custom_blocks/widgets/videoLibraryBlock'


export const CustomBlock_To_Widget = (c: CustomBlock, block_index: number, extra_data: PublicSite_CustomPageData): Option<CustomBlockData> => {
  if (c.kind == 'vidda/page-navigation') {
    let nav: CustomBlockData = {
      kind: "pageNavigationBlock",
      value: {
        fst: {},
        snd: PageNavigationBlockClasses
      }
    }

    return some(nav)
  }
  if (c.kind == 'vidda/image-text') {
    let img_text: CustomBlockData = {
      kind: 'TextWithImageBlockData',
      value: {
        fst: {
          blockName: c.kind,
          image: c.attrs.image,
          title: c.attrs.title,
          intro: c.innerBlocks.reduce((ys, y) => ys + y.innerContent.reduce((xs, x) => xs + x, ""), ""),
          image_position: c.attrs.image_position,
          isAnimation: c.attrs.isAnimation,
          animation_data: c.attrs.animation_data ? toRelativeUrl(c.attrs.animation_data) : undefined,
          show_in_page_navigation: c.attrs.show_in_page_navigation,
          navigation_title: c.attrs.navigation_title ? c.attrs.navigation_title : c.attrs.title
        },
        snd: {}
      }
    }
    return some(img_text)
  }
  if (c.kind == 'vidda/animation-lotti') {
    let lotti: CustomBlockData = {
      kind: 'LottiAnimationBlock',
      value: {
        fst: {
          block_index: block_index,
          animation_data_url: toRelativeUrl(c.attrs.animation_data),
          caption: c.attrs.caption
        },
        snd: {}
      }
    }
    return some(lotti)
  }
  if (c.kind == 'vidda/video-library') {
    let videoLibrary: CustomBlockData = {
      kind: 'videoLibraryBlock',
      value: {
        fst: {
          block_index: block_index,
          video_id: c.attrs.video_id,
          title: c.attrs.title,
          intro: c.attrs.intro,
          image: c.attrs.image,
          selected_video_url: "",
          selected_video_type: "",
          video: loadingAsyncState(() => {
            return FindHighlightVideoItem(c.attrs.video_id)
          }),
          show_highlight: c.attrs.show_highlight,

          video_filters: loadingAsyncState(() => {
            let list_video_id: string[] = []
            c.innerBlocks.map(block => {
              list_video_id.push(block.attrs.video_id)
            })
            return GetVideoLibraryFilters(list_video_id)
          }),
          selectedTag: AllVideosText,
          isOpen: 'close',
          items: loadingAsyncState(() => {
            let list_video_id: string[] = []
            c.innerBlocks.map(block => {
              list_video_id.push(block.attrs.video_id)
            })
            return FindVideoLibraryItems(list_video_id)
          }),

          show_in_page_navigation: c.attrs.show_in_page_navigation,
          navigation_title: c.attrs.navigation_title ? c.attrs.navigation_title : c.attrs.title
        },
        snd: {}
      }
    }
    return some(videoLibrary)
  }
  if (c.kind == 'vidda/grid') {
    let grid: CustomBlockData = {
      kind: 'gridBlock',
      value: {
        fst: {
          title: c.attrs.title,
          intro: c.attrs.intro,
          show_primary: c.attrs.show_primary,
          primary_button: linkWrapper({ title: c.attrs.primary_button_text, url: c.attrs.primary_button_url }),
          items: c.innerBlocks.map(block => ({
            title: block.attrs.title,
            has_link: block.attrs.has_link,
            intro: block.attrs.intro,
            label: block.attrs.label,
            link: linkWrapper({ title: block.attrs.link_text, url: block.attrs.link_url })
          })),
          show_in_page_navigation: c.attrs.show_in_page_navigation,
          navigation_title: c.attrs.navigation_title ? c.attrs.navigation_title : c.attrs.title
        },
        snd: {}
      }
    }
    return some(grid)
  }
  if (c.kind == 'vidda/grid-with-image') {
    let grid_with_image: CustomBlockData = {
      kind: 'gridWithImageBlock',
      value: {
        fst: {
          title: c.attrs.title,
          intro: c.attrs.intro,
          show_primary: c.attrs.show_primary,
          primary_button: linkWrapper({ title: c.attrs.primary_button_text, url: c.attrs.primary_button_url }),
          items: c.innerBlocks.map(block => ({
            title: block.attrs.title,
            has_link: block.attrs.has_link,
            intro: block.attrs.intro,
            label: block.attrs.label,
            link: linkWrapper({ title: block.attrs.link_text, url: block.attrs.link_url }),
            image: block.attrs.image,
            animation_data: block.attrs.animation_data, 
            isAnimation: block.attrs.isAnimation
          })),
          show_in_page_navigation: c.attrs.show_in_page_navigation,
          navigation_title: c.attrs.navigation_title ? c.attrs.navigation_title : c.attrs.title
        },
        snd: {}
      }
    }
    return some(grid_with_image)
  }
  if (c.kind == 'vidda/map') {
    let map_options: Map<string, string> = Map()
    if (extra_data.extra_params) {
      extra_data.extra_params.forEach(ps => {
        if (ps.find(p => p.param == 'kind' && p.value == 'map')) {
          ps.forEach(p => {
            map_options = map_options.set(p.param, p.value)
          })
        }
      })
    }
    const vidda_map: CustomBlockData = {
      kind: 'mapBlock',
      value: {
        fst: {
          addresses: get_addresses(),
          state: conneqt_x_map(
            extra_data.extra_params,
            map_options.get('city')
          ),
          block_index
        },
        snd: {
          // styling
        }
      }
    }
    return some(vidda_map)
  }
  if (c.kind == 'vidda/download') {
    const vidda_download: CustomBlockData = {
      kind: 'downloadsBlock',
      value: {
        fst: {
          block_index: block_index,
          title: c.attrs.title,
          intro: c.attrs.intro,
          items: c.attrs.downloads.map((item, index) => {
            return {
              title: item.title,
              url: item.url,
              file_name: item.file_name,
              key: index.toString()
            }
          }),
          show_in_page_navigation: c.attrs.show_in_page_navigation,
          navigation_title: c.attrs.navigation_title ? c.attrs.navigation_title : c.attrs.title
        },
        snd: downloadBlockClasses as DownloadBlockStyle
      }
    }
    return some(vidda_download)
  }
  if (c.kind == 'vidda/text') {
    const vidda_text: CustomBlockData = {
      kind: 'textBlock',
      value: {
        fst: {
          key: `text-${block_index}`,
          title: c.attrs.title,
          text: c.attrs.text,
          primary_button: (c.attrs.show_button && c.attrs.button_text && c.attrs.button_url)
            ? buttonWrapper({ title: c.attrs.button_text, url: c.attrs.button_url })
            : null,
          link: {
            kind: 'link',
            is_link_external: true,
            target: '_self',
            url: c.attrs.link_url,
            title: c.attrs.link_text
          },
          show_in_page_navigation: c.attrs.show_in_page_navigation,
          navigation_title: c.attrs.navigation_title ? c.attrs.navigation_title : c.attrs.title, 
          animation_data: c.attrs.animation_data
        },
        snd: textBlockClasses
      }
    }
    return some(vidda_text)
  }

  if (c.kind == 'vidda/download-item') {
    const vidda_download_item: CustomBlockData = {
      kind: 'downloadItemBlock',
      value: {
        fst: {
          key: `download-item-${block_index}`,
          title: c.attrs.title,
          url: c.attrs.url,
          file_name: c.attrs.file_name,
          show_in_page_navigation: c.attrs.show_in_page_navigation,
          navigation_title: c.attrs.navigation_title ? c.attrs.navigation_title : c.attrs.title
        },
        snd: downloadBlockClasses
      }
    }
    return some(vidda_download_item)
  }

  if (c.kind == 'vidda/form') {
    return some({
      kind: 'formBlock',
      value: {
        fst: {
          block_index: block_index,
          form_id: c.attrs.form_id,
          state: getFormState([], c.attrs.form_id)
        },
        snd: formBlockClasses
      }
    })
  }

  if (c.kind == 'vidda/table') {
    return some({
      kind: 'tableBlock',
      value: {
        fst: {
          block_index: block_index,
          //call function to parse html to check values > string to string
          html: parseTableHtml(c.attrs.html) // <hier in 
        },
        snd: tableBlockClasses
      }
    })
  }

  if (c.kind == 'vidda/latest') {

    let blockProps: LatestBlockProps = {
      title: c.attrs.title,
      button: {
        title: 'Bekijk alle updates',
        url: '/updates'
      },
      hasBackground: c.attrs.hasBackground,
      display: c.attrs.variant == 'selected' ? { kind: 'selected', ids: [] } : { kind: 'latest' },
      show_in_page_navigation: c.attrs.show_in_page_navigation,
      navigation_title: c.attrs.navigation_title ? c.attrs.navigation_title : c.attrs.title
    }

    return some({
      kind: 'latestBlock',
      value: {
        fst: blockProps,
        snd: textBlockClasses
      }
    })
  }

  if (c.kind == 'core/list' || c.kind == 'core/heading' || c.kind == 'core/paragraph') {
    return some({
      kind: 'coreBlock',
      value: {
        fst: {
          text: c.innerHTML
        },
        snd: textBlockClasses
      }
    })
  }

  if (c.kind == 'vidda/storyblock') {
    return some({
      kind: 'storyBlock',
      value: {
        fst: {
          blocks: c.innerBlocks.map(block => {
            return {
              title: block.attrs.title,
              intro: block.attrs.intro,
              button_text: block.attrs.button_title,
              button_url: block.attrs.button_url
            }
          })
        },
        snd: {}
      }
    })
  }

  if (c.kind == 'vidda/media') {
    const vidda_media: CustomBlockData = {
      kind: 'mediaBlock',
      value: {
        fst: {
          block_index,
          kind_media: c.attrs.type,
          caption: c.attrs.caption,
          image: c.attrs.type == 'video' ? null : c.attrs.image,
          size: 'media',
          get_default_data_src: null,
          get_default_data_srcset: null,
          video: c.attrs.type == 'video' && {
            id: c.attrs.video.id,
            url: c.attrs.video.url,
            type: 'youtube',
            width: '100%',
            height: '',
            frameBorder: 'none',
            allowFullScreen: false
          },
          useCookieBar: true
        },
        snd: mediaBlockClasses as MediaBlockStyle
      }
    }
    return some(vidda_media)
  }

  if (c.kind == 'vidda/quote') {
    const vidda_quote: CustomBlockData = {
      kind: 'quoteBlock',
      value: {
        fst: {
          text: c.attrs.text,
          author: c.attrs.author,
          image: c.attrs.image,
          link_url: c.attrs.button_url,
          link_title: c.attrs.button_text,
          show_in_page_navigation: c.attrs.show_in_page_navigation,
          navigation_title: c.attrs.navigation_title ? c.attrs.navigation_title : ""
        },
        snd: quoteBlockClasses as QuoteBlockStyle
      }
    }

    return some(vidda_quote)
  }

  if (c.kind == 'vidda/iframe') {
    return some({
      kind: 'iframeBlock',
      value: {
        fst: {
          block_index,
          link: c.attrs.url,
          with: '100%',
          height: c.attrs.height
        },
        snd: iframeBlockClasses
      }
    } as CustomBlockData)
  }

  if (c.kind == 'vidda/rekentool-maximalehypotheek') {
    return some({
      kind: 'rekenToolBlock',
      value: {
        fst: {
          block_index,
          // TODO: Can't display this iframe because X-Frame-Options is not defined
          url: 'https://rekentools.webbridge.nl/hypotrust/maximalehypotheek'
        },
        snd: rekenToolBlockClasses
      }
    } as CustomBlockData)
  }

  if (c.kind == 'vidda/rekentool-hypotheekoversluiten') {
    return some({
      kind: 'rekenToolBlock',
      value: {
        fst: {
          block_index,
          url: 'https://rekentools.webbridge.nl/hypotrust/hypotheekoversluiten'
        },
        snd: rekenToolBlockClasses
      }
    } as CustomBlockData)
  }

  if (c.kind == 'vidda/hero') {
    const vidda_hero: CustomBlockData = {
      kind: 'heroBlock',
      value: {
        fst: c.attrs,
        snd: textBlockClasses as QuoteBlockStyle
      }
    }

    return some(vidda_hero)
  }

  if (c.kind == 'vidda/video-cta') {
    const vidda_cta_video: CustomBlockData = {
      kind: 'videoCtaBlock',
      value: {
        fst: {
          title: c.attrs.title ? c.attrs.title : "",
          intro: c.attrs.intro ? c.attrs.intro : "",
          show_primary: c.attrs.show_primary,
          video_url: c.attrs.video_url ? c.attrs.video_url : undefined,
          primary_button: c.attrs.show_primary && c.attrs.primary_button_text ? linkWrapper({ title: c.attrs.primary_button_text, url: c.attrs.primary_button_url }) : undefined,
          show_in_page_navigation: c.attrs.show_in_page_navigation,
          navigation_title: c.attrs.navigation_title ? c.attrs.navigation_title : c.attrs.title
        },
        snd: {}
      }
    }

    return some(vidda_cta_video)
  }

  return none()
}


// WEBPACK FOOTER //
// ./Client/components/public_site/CustomBlockToWidget.ts